import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import {
  Popup,
  SquareBorderButton,
  Icon,
  HoverAccentButton,
  Text
} from '@lyearn-team/frontend-components';
import { withTheme } from 'emotion-theming';

import * as s from './styles';

@withTheme
@inject(stores => ({ model: stores.liveClassModel }))
@observer
class EndLiveClassPopup extends Component {
  render() {
    const { model } = this.props;
    const { isMobile } = model.store;
    const { isPopupVisible } = model.store.endLiveClass;

    if (!isPopupVisible) {
      return null;
    }

    const { theme } = this.props;
    const { handleExit } = model.store.endLiveClass;

    return (
      <Popup
        onCloseClick={handleExit}
        header={null}
        footer={null}
        showPopup={true}
        popupClassName={s.popup}
      >
        <HoverAccentButton
          icon={{ type: 'close' }}
          className={s.closeButton}
          onClick={handleExit}
        />
        <div className={s.iconContainer}>
          <Icon type="assignments" className={s.traningsIcon} iconColor={theme.color.black3} />
          <Icon type="circleCheck" className={s.checkIcon(theme)} />
        </div>
        <Text.H2 className={s.info}>Session is successfully finished.</Text.H2>
        <SquareBorderButton text="Exit" onClick={handleExit} className={s.exitButton(isMobile)} />
      </Popup>
    );
  }
}

export default EndLiveClassPopup;
